<template>
    <button v-bind="$attrs" class="text-sky-700 font-medium pr-4 py-1 active:text-sky-500 flex items-center">
        <i class="icon-chevron-left text-2xl"></i>
        <slot></slot>
    </button>
</template>

<script setup lang="ts">

defineProps<{
    disabled?: boolean;
}>();
</script>
